import React from "react";

import { HiMail } from "react-icons/hi";
import { HiOutlineClock } from "react-icons/hi2";

import CrispButton from "@shared/components/CrispButton";

export default function SupportPage() {
  return (
    <div className="h-screen w-screen bg-gray-50 p-4 flex items-center justify-center">
      <div className="max-w-md mx-auto bg-white rounded-lg shadow-sm p-8 space-y-6">
        {/* Heading */}
        <div className="text-center">
          <h1 className="text-2xl font-semibold text-gray-900 mb-2">
            Need Help?
          </h1>
          <p className="text-gray-600">
            We&apos;re here to help you with any questions or issues.
          </p>
        </div>

        {/* Crisp Chatbox */}
        <div className="space-y-3">
          <h2 className="text-lg font-medium text-gray-900">Chat with us</h2>
          <CrispButton className="w-full" />
        </div>

        {/* Support Email */}
        <div className="space-y-3">
          <h2 className="text-lg font-medium text-gray-900">Email Support</h2>
          <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
            <HiMail className="text-gray-500 flex-shrink-0" />
            <a
              href="mailto:assistant@modaresa.com"
              className="text-primaryElectricBlue hover:underline"
            >
              assistant@modaresa.com
            </a>
          </div>
        </div>

        {/* Business Hours */}
        <div className="space-y-3">
          <h2 className="text-lg font-medium text-gray-900">Business Hours</h2>
          <div className="flex items-start space-x-3 p-3 bg-gray-50 rounded-lg">
            <HiOutlineClock className="text-gray-500 flex-shrink-0 mt-0.5" />
            <div className="text-gray-700">
              <p className="font-medium">Monday to Friday</p>
              <p>09:00 - 18:00 (Paris time)</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
